var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcJpg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M20,4c1.1,0,2,0.9,2,2l0,0v12c0,1.1-0.9,2-2,2l0,0H4c-1.1,0-2-0.9-2-2l0,0L2,6c0-1.1,0.9-2,2-2l0,0H20z  M7.1,8.7H5.5v4.2c0,0.3-0.1,0.4-0.2,0.6c-0.1,0.1-0.3,0.2-0.6,0.2c-0.1,0-0.3,0-0.4,0S4.1,13.6,4,13.5v1.4C4.1,15,4.3,15,4.5,15.1 c0.2,0,0.4,0.1,0.6,0.1c0.6,0,1.1-0.2,1.5-0.5c0.3-0.4,0.5-0.9,0.5-1.5V8.7z M17.6,8.6c-0.7,0-1.3,0.1-1.8,0.4 c-0.5,0.3-0.9,0.6-1.2,1.1c-0.3,0.5-0.4,1.1-0.4,1.7c0,0.7,0.1,1.2,0.4,1.7c0.3,0.5,0.7,0.9,1.2,1.1s1.1,0.4,1.8,0.4 c0.9,0,1.7-0.2,2.4-0.6v-3.1h-2.5v1.1h1v1c-0.2,0.1-0.5,0.2-0.8,0.2c-0.6,0-1-0.2-1.4-0.5s-0.5-0.8-0.5-1.3c0-0.4,0.1-0.7,0.3-1 c0.2-0.3,0.4-0.5,0.7-0.6c0.3-0.1,0.6-0.2,1-0.2c0.4,0,0.8,0,1.1,0.1s0.6,0.2,0.9,0.5V9.1c-0.3-0.2-0.6-0.3-1-0.4S18.1,8.6,17.6,8.6 z M11.2,8.7H8.4V15H10v-1.9h1.2c0.7,0,1.3-0.2,1.8-0.6c0.4-0.4,0.7-0.9,0.7-1.6c0-0.7-0.2-1.2-0.7-1.6C12.5,8.9,11.9,8.7,11.2,8.7z  M10.9,10c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.3,0.3,0.3,0.7s-0.1,0.6-0.3,0.7c-0.2,0.1-0.4,0.2-0.8,0.2H10V10H10.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJpg);
export default __webpack_public_path__ + "static/media/ic_JPG.73e96014.svg";
export { ForwardRef as ReactComponent };